export default __webpack_public_path__ + "static/media/bubbles.3e8e3a6e.png";